<template>
  <v-sheet class="pa-2" border color="grey-lighten-5" elevation="0">
    <div class="text-h6">
      Inscription {{ inscription.nom }} {{ inscription.prenom }} <span v-if="!type == 'refund'">| ID. {{ inscription.id }}</span>
    </div>
    <div>Course : {{ inscription.course.nom }} | Sexe : {{ inscription.sexe }} | Club : {{ inscription.club }} | Date naissance : {{ inscription.date_naissance }}</div>

    <div class="d-flex sm-gap">
      <v-chip variant="elevated" color="white" elevation="0" border>Inscription <span v-if="inscription.inscription_sportive == '0'">non</span> sportive</v-chip>

      <v-chip variant="elevated" color="white" elevation="0" border>
        <v-icon v-if="inscription.paye == '1'" icon="mdi-check" color="green-darken-4"></v-icon>
        <v-icon v-else icon="mdi-close" color="deep-orange-darken-4"></v-icon>
        Payée
      </v-chip>
      <v-chip variant="elevated" color="white" elevation="0" border>
        <v-icon v-if="inscription.affiche == '1'" icon="mdi-check" color="green-darken-4"></v-icon>
        <v-icon v-else icon="mdi-close" color="deep-orange-darken-4"></v-icon>
        Affichée
      </v-chip>
      <v-chip variant="elevated" color="white" elevation="0" border>
        <v-icon v-if="inscription.document_recu == '1'" icon="mdi-check" color="green-darken-4"></v-icon>
        <v-icon v-else icon="mdi-close" color="deep-orange-darken-4"></v-icon>
        Doc. reçu
      </v-chip>
      <v-chip variant="elevated" color="white" elevation="0" border>
        <v-icon v-if="inscription.document_valide == '1'" icon="mdi-check" color="green-darken-4"></v-icon>
        <v-icon v-else icon="mdi-close" color="deep-orange-darken-4"></v-icon>
        Doc. validé
      </v-chip>
      <v-chip variant="elevated" color="white" elevation="0" border>
        <v-icon v-if="inscription.valide == '1'" icon="mdi-check" color="green-darken-4"></v-icon>
        <v-icon v-else icon="mdi-close" color="deep-orange-darken-4"></v-icon>
        Inscription validée
      </v-chip>

      <v-chip variant="elevated" color="red-darken-4" elevation="0" border v-if="inscription.supprime == '1'">
        <v-icon icon="mdi-check" color="white"></v-icon>
        Inscription supprimée
      </v-chip>
      <v-chip variant="elevated" color="red-darken-4" elevation="0" border v-if="inscription.transfere == '1'">
        <v-icon icon="mdi-check" color="white"></v-icon>
        Inscription transferée
      </v-chip>
    </div>
    <div class="d-flex flex-wrap sm-gap mt-2" v-if="!type == 'refund'">
      <v-btn size="small" @click="send_email_client()">Renvoyer le QR Code d'inscription à {{ inscription.coureur.champs.mail }}</v-btn>

      <v-btn size="small" @click="send_email_yann()">Renvoyer le QR Code d'inscription à yann@sportips.fr</v-btn>
    </div>
  </v-sheet>
</template>

<script>
import axios from "axios";
export default {
  props: ["inscription", "type"],
  methods: {
    async send_email_client() {
      let res = await axios.post("/emails/send_j_minus_3.php", {
        id_inscription: this.inscription.id,
      });
      if (res.data.error) {
        console.log(res.data.error);
      }
    },
    async send_email_yann() {
      let res = await axios.post("/emails/send_j_minus_3.php", {
        id_inscription: this.inscription.id,
        override_email: "yann@sportips.fr",
      });
      if (res.data.error) {
        console.log(res.data.error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>